/**
 * Права кабинета AQSI: одно место для строк, по которым сервер отбирает ресурсы и выдаёт доступ к окнам (FEAT-04).
 * Значения — слова договора с Platform; менять их нельзя, их знают сервер и выданные права.
 */
export const AQSI_RIGHTS = {
  catalogRead: 'catalog.read',
  /** Запись карточек кабинета: правка в окне товара и «Создание по умолчанию» (RP-SYN12). */
  catalogWrite: 'catalog.write',
  pricesWrite: 'prices.write',
  devicesRead: 'devices.read',
  deliveryRead: 'delivery.read',
  sessionOpen: 'session.open',
  sessionTakeover: 'session.takeover',
  sessionCloseAny: 'session.close-any',
  sessionJournalRead: 'session.journal.read',
  receiptsRead: 'receipts.read',
  salesManage: 'sales.manage',
  salesRead: 'sales.read',
  salesPrice: 'sales.price',
  salesTrace: 'sales.trace',
} as const
